import { getShowFullHierarchy } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/filter-options/show-full-hierarchy';
import { createSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';

const mapStateToProps = createSelector([getShowFullHierarchy], (showFullHierarchy) => ({
	showFullHierarchy,
}));
export default mapStateToProps;
